// src/modules/IntegratedMessaging/hooks/useUpdateIntegration.ts

import { useMutation } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { IntegratedMessagingApiAdapter } from '../adapters/IntegratedMessagingApiAdapter';

export interface UpdateIntegrationPayload {
  id: number;
  name?: string | null;
  data: Record<string, any>;
  visibility?: 'public' | 'private';
  private_team_ids?: number[];
}

export const useUpdateIntegration = () => {
  // Creamos el httpClient y el adapter dentro del hook,
  // pasando apiClientWH a createHttpClient.
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new IntegratedMessagingApiAdapter(httpClient);

  // Tipamos la mutación para que isLoading, mutate, etc. estén disponibles
  return useMutation<void, Error, UpdateIntegrationPayload>({
    mutationFn: ({ id, name, data }) =>
      adapter.updateIntegration(id, { name, data }),
  });
};
